import { FC, useMemo, useState, useRef, } from "react";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { ProModal, ProForm, ProInput, ProButton, } from '../antd';
import { responseSuccess } from '../utils/messageUtils';
import { ExamineOrderProps, AuditOrderType, } from "./interface";
import { IObject } from '../constants/interface';
import { SUCCESS_STATUS_CODE } from "../constants/constant";
import { Rule } from "antd/lib/form";
import './style.less';

/** 审核（通过和驳回在同一个弹窗） */
const ExamineOrder: FC<ExamineOrderProps> = props => {
  const {
    title, orderSn, otherParams, required, label, name, orderId, orderIdName, actionRef, rejectButtonText, passButtonText, width, successTip,
    passApi, rejectApi, onSuccess, onError, ...restProps
  } = props;
  const [visible, setVisible] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const buttonType = useRef<AuditOrderType>(); // 点击的按钮类型
  const [form] = ProForm.useForm();
  /** 显示 */
  const handleShow = () => {
    setVisible(true);
    form.resetFields();
  };
  /** 隐藏 */
  const handleHide = () => {
    setVisible(false);
  };
  /** 点击驳回按钮 */
  const handleReject = () => {
    buttonType.current = 'reject';
    form.submit();
  };
  /** 点击通过按钮 */
  const handlePass = () => {
    buttonType.current = 'pass';
    form.submit();
  };
  /** 提交 */
  const handleFinish = async (values: any) => {
    const params: IObject = { ...values, ...otherParams };
    if (orderIdName && orderId) params[orderIdName] = orderId;
    const fetchApi = buttonType.current === 'pass' ? passApi : rejectApi;
    setLoading(true);
    const passRes = await fetchApi(params);
    setLoading(false);
    handleHide();
    if (passRes && passRes.code === SUCCESS_STATUS_CODE) {
      const data = passRes.data;
      successTip && responseSuccess(successTip);
      onSuccess?.(data);
      return;
    }
    onError?.(passRes);
  };
  /** 底部按钮 */
  const footer = useMemo(() => {
    return [
      <ProButton type='default' loading={buttonType.current === 'reject' && loading} danger onClick={handleReject}>{rejectButtonText}</ProButton>,
      <ProButton type='primary' loading={buttonType.current === 'pass' && loading} onClick={handlePass}>{passButtonText}</ProButton>,
    ];
  }, [loading, visible, rejectButtonText, passButtonText, orderSn]);
  /** 审批意见表单验证 */
  const textAreaRule: Rule[] | undefined = useMemo(() => {
    if (required) {
      return [
        {
          required: true,
          message: `请输入${label}`,
        },
      ];
    }
  }, [label, required]);
  /** 对外方法 */
  if (actionRef) {
    actionRef.current = {
      show: handleShow,
      hide: handleHide,
    };
  }
  return (
    <ProModal
      open={visible}
      destroyOnClose
      width={width}
      onCancel={handleHide}
      footer={footer}
      {...restProps}
    >
      <div className="yb-audit-order">
        <div className="yb-audit-order-title">
          <ExclamationCircleOutlined className="yb-audit-order-title-icon" />
          <span>{title}</span>
          {
            !!orderSn && (
              <span className="p-l-s">{orderSn}？</span>
            )
          }
        </div>
        <div>
          <ProForm form={form} onFinish={handleFinish}>
            <ProForm.Item label={label} name={name} rules={textAreaRule}>
              <ProInput.TextArea rows={4} showCount={true} placeholder="请填写审批意见，最多200个字" />
            </ProForm.Item>
          </ProForm>
        </div>
      </div>
    </ProModal>
  );
};

ExamineOrder.defaultProps = {
  label: '审批意见',
  name: 'auditorComment',
  title: '审核',
  rejectButtonText: '驳回',
  passButtonText: '通过',
  width: 416,
  successTip: '操作成功',
};

export default ExamineOrder;
